import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateImgMeasures = atom({
  key: 'beacon.img.measures',
  default: [] as BeaconFilterItem[],
});

export default stateImgMeasures;
